var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',{staticClass:"primary--text"},[_vm._v(" Transactions ")]),_c('div',{staticClass:"pa-2"},[_c('TransactionsList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }